export const toString = (obj) => Object.prototype.toString.call(obj);

export const isObject = (obj) => {
  return toString(obj) === '[object Object]';
};

/**
 * 判断一个对象是否为空
 * @param obj 普通的对象
 */
export const isEmpty = (obj) => !Object.keys(obj).length;

/**
 * 过滤对象的属性，默认过滤出值为 undefined 和 null 的属性
 * @param obj 普通的对象
 * @param compare 比较函数，返回 true 时属性会被保留
 */
export const filter = (obj, compare) => {
  const filterFn = ([k, v]) =>
    typeof compare === 'function' ? compare(k, v) : typeof v !== 'undefined' && v !== null;

  return Object.fromEntries(Object.entries(obj).filter(filterFn));
};
